import { Modal, Button, Form } from 'react-bootstrap';

const RemarkModal = ({
  isOpen,
  onClose,
  value,
  onChange,
  onSubmit,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Remark</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group controlId="remarkTextarea">
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter remark..."
            value={value}
            onChange={onChange}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSubmit} disabled={!value}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemarkModal;
